import React from "react";
import PropTypes from "prop-types";
import RtrButton from "components/design-system/rtr-button";

const propTypes = {
  onClick: PropTypes.func,
  ctaCopy: PropTypes.string,
};

const FeedbackFooter = ({ onClick = () => {}, ctaCopy }) => {
  return (
    <div
      className="bg-white w-full flex justify-center items-center p-4 sm:py-6 sticky bottom-0 border-t border-lighterGray z-50"
      data-test-id="happiness-survey-footer">
      <RtrButton fullWidth onClick={onClick} data-test-id="happiness-survey-footer-primary-cta">
        {ctaCopy}
      </RtrButton>
    </div>
  );
};

FeedbackFooter.propTypes = propTypes;
export default FeedbackFooter;
